module.exports = __webpack_public_path__ + "static/media/logo-horizontal-white.afc5a733.png";